import React from 'react'

import { Navbar } from '../../components';

const NoPage = () => (
    <div>
      <Navbar isHome={false}/>
      404 page not found
    </div>
  );

export default NoPage;